// RewardVoucher Actions
import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addRewardVoucher = (voucherData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REWARD_VOUCHER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-voucher/add`, voucherData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REWARD_VOUCHER_SUCCESS", payload: data });
        // toast.success("Reward voucher added successfully!");
        return data; // Return data for component to handle
      } else {
        dispatch({ type: "ADD_REWARD_VOUCHER_FAILED", payload: data });
        // toast.error("Failed to add reward voucher");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_REWARD_VOUCHER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error adding reward voucher");
      console.error("Error in addRewardVoucher:", error);
      return error?.response?.data || {};
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listRewardVouchers = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) {
      dispatch({ type: "START_LOADING" });
    }
    try {
      dispatch({ type: "LIST_REWARD_VOUCHERS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-voucher/list`, filterData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_REWARD_VOUCHERS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_REWARD_VOUCHERS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_REWARD_VOUCHERS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewRewardVoucher = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_REWARD_VOUCHER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(`${BASE_URL}/reward-voucher/view/${id}`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_REWARD_VOUCHER_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_REWARD_VOUCHER_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_REWARD_VOUCHER_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRewardVoucher = (updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REWARD_VOUCHER_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-voucher/update`, updateData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REWARD_VOUCHER_SUCCESS", payload: data });
        toast.success("Reward voucher updated successfully!");
        // Optionally refresh view
        dispatch(viewRewardVoucher(updateData.id));
        return data;
      } else {
        dispatch({ type: "UPDATE_REWARD_VOUCHER_FAILED", payload: data });
        toast.error("Failed to update reward voucher");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REWARD_VOUCHER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error updating reward voucher");
      console.error("Error updating reward voucher:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeRewardVoucher = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_REWARD_VOUCHER_REQUEST" });

      const { data } = await axios.delete(`${BASE_URL}/reward-voucher/remove/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_REWARD_VOUCHER_SUCCESS", payload: id });
        toast.success("Reward voucher removed successfully!");
      } else {
        dispatch({ type: "REMOVE_REWARD_VOUCHER_FAILED", payload: data });
        toast.error("Failed to remove reward voucher");
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_REWARD_VOUCHER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error removing reward voucher");
      console.error("Error removing reward voucher:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const addRewardPoints = (pointsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REWARD_POINTS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-point/add`, pointsData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REWARD_POINTS_SUCCESS", payload: data });
        toast.success("Reward points added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_REWARD_POINTS_FAILED", payload: data });
        toast.error("Failed to add reward points");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error adding reward points");
      console.error("Error in addRewardPoints:", error);
      return error?.response?.data || {};
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listRewardPoints = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_REWARD_USER_POINTS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-point/list`, filterData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_REWARD_USER_POINTS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_REWARD_USER_POINTS_FAILED", payload: data });
        toast.error("Failed to fetch reward points");
      }
    } catch (error) {
      dispatch({
        type: "LIST_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching reward points");
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRewardPoints = (updateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_REWARD_POINTS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-point/update`, updateData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_REWARD_POINTS_SUCCESS", payload: data });
        toast.success("Reward points updated successfully!");
        return data;  // Return data here so calling function can check success
      } else {
        dispatch({ type: "UPDATE_REWARD_POINTS_FAILED", payload: data });
        toast.error("Failed to update reward points");
        return data;  // Return data to indicate failure to caller
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error updating reward points");
      console.error("Error updating reward points:", error);
      return { error: error?.response?.data?.message || "Unknown error" };
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewRewardPoints = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_REWARD_POINTS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-point/view/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_REWARD_POINTS_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_REWARD_POINTS_FAILED", payload: data });
        toast.error("Failed to fetch reward points details");
      }
    } catch (error) {
      dispatch({
        type: "VIEW_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching reward points details");
      console.error("Error in viewRewardPoints:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const removeRewardPoints = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_REWARD_POINTS_REQUEST" });

      const { data } = await axios.delete(`${BASE_URL}/reward-point/remove/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_REWARD_POINTS_SUCCESS", payload: id });
        toast.success("Reward points removed successfully!");
      } else {
        dispatch({ type: "REMOVE_REWARD_POINTS_FAILED", payload: data });
        toast.error("Failed to remove reward points");
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_REWARD_POINTS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error removing reward points");
      console.error("Error removing reward points:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listRewardUser = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_REWARD_USER_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-user/list`, filterData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_REWARD_USER_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_REWARD_USER_FAILED", payload: data });
        toast.error("Failed to fetch reward User");
      }
    } catch (error) {
      dispatch({
        type: "LIST_REWARD_USER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching reward user");
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewRewardUser = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_REWARD_USER_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(`${BASE_URL}/reward-user/view/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_REWARD_USER_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_REWARD_USER_FAILED", payload: data });
        toast.error("Failed to fetch reward points details");
      }
    } catch (error) {
      dispatch({
        type: "VIEW_REWARD_USER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching reward details");
      console.error("Error in viewRewardUser:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewDoneRewardUser = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_DONE_REWARD_USER_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(`${BASE_URL}/reward-done-user/view/${id}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_DONE_REWARD_USER_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_DONE_REWARD_USER_FAILED", payload: data });
        toast.error("Failed to fetch Done reward User details");
      }
    } catch (error) {
      dispatch({
        type: "VIEW_DONE_REWARD_USER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error fetching done reward user details");
      console.error("Error in viewDoneRewardUser:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const removeRewardUser = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_REWARD_USER_REQUEST" });

      const { data } = await axios.delete(`${BASE_URL}/reward-user/remove/${id}`);

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_REWARD_USER_SUCCESS", payload: id });
        toast.success("Reward points removed successfully!");
      } else {
        dispatch({ type: "REMOVE_REWARD_USER_FAILED", payload: data });
        toast.error("Failed to remove reward");
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_REWARD_USER_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Error removing reward");
      console.error("Error removing reward :", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listRewardHistoryUsers = (filterData, showLoader = true) => {
  return async (dispatch) => {
    if (showLoader) dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_REWARD_HISTORY_USERS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/reward-done-user/list`, filterData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_REWARD_HISTORY_USERS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_REWARD_HISTORY_USERS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_REWARD_HISTORY_USERS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) dispatch({ type: "STOP_LOADING" });
    }
  };
};
